import jquery from "jquery";
import { lockBody, unlockBody } from "@plugins";
window.$ = window.jQuery = jquery;
require("@fancyapps/fancybox");

// Оnключаем смену фокуса при закрытии фото Fancybox , чтобы не ломать swiper
$.fancybox.defaults.backFocus = false;
$.fancybox.defaults.hideScrollbar = false;
$.fancybox.defaults.video.format = "video/mp4";

$("[data-fancybox]").fancybox({
    animationEffect: "zoom",
    animationDuration: 250,
    hideScrollbar: false,
    backFocus: false,
    padding: 0,
    helpers: {
        overlay: {
            locked: false, // отключаем блокировку overlay
        },
    },
    onActivate: (instance) => {
        lockBody(instance, {
            reserveScrollBarGap: true,
        });
    },
    beforeClose: (instance) => {
        unlockBody(instance);
    },
    caption: function () {
        const captionText = $(this).data("caption-text");
        const captionLink = $(this).data("caption-link");

        if (captionText && captionLink) {
            return `<a class="fancybox__caption-link" href="${captionLink}" target="_blank" rel="noopener nofollow">${captionText}</a>`
        }

        if (captionText && !captionLink) {
            return `<p class="fancybox__caption-text">${captionText}</p>`
        }

        return "";
    },
});

